module.exports = __webpack_public_path__ + "assets/freshchat.091fab0b.svg";